import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Radio,
  Stack,
  Typography,
  useMediaQuery,
  Paper,
} from "@mui/material";
import { useRef, useState } from "react";
import "react-notifications/lib/notifications.css";

//import for our files
import { useReactToPrint } from "react-to-print";
import { useParams } from "react-router-dom";
import { useQuery } from "react-query";
import { toast } from "react-toastify";
import {
  selectFeeInvoicePrintPreferences,
  setFeeInvoicePrintPreferences,
} from "app/services/commonSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  getFeeInvoice,
  getFeeInvoiceTemplate2,
} from "app/services/schoolService/newFee.service";
import CustomLoader from "../../common/CustomLoader";
import InvoiceTemplate1 from "./InvoiceTemplate1";
import InvoiceTemplate2 from "./InvoiceTemplate2";
import PrintIcon from "@mui/icons-material/Print";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";

export default function InvoiceComponent2() {
  const isMobile = useMediaQuery("(max-width:768px)");
  const invoicePrintRef = useRef(null);
  const [data, setData] = useState({});
  const [data2, setData2] = useState({});
  const [invoiceItems, setInvoiceItems] = useState([]);
  const [invoiceItems2, setInvoiceItems2] = useState([]);
  const { invoiceId } = useParams();
  const dispatch = useDispatch();
  const feeInvoicePrint = useSelector(selectFeeInvoicePrintPreferences);
  const state = {
    school: feeInvoicePrint.school,
    student: feeInvoicePrint.student,
    template:
      feeInvoicePrint.template === "template2" ? "template2" : "template1",
  };
  const keepHeaderSpace = feeInvoicePrint.keepHeaderSpace;
  const printTheme = feeInvoicePrint.printTheme === "bw" ? "bw" : "color";
  const patchFeeInvoicePrint = (partial) =>
    dispatch(setFeeInvoicePrintPreferences(partial));

  const handlePrint = useReactToPrint({
    content: () => invoicePrintRef.current,
  });
  const { isLoading: getFeeInvoiceLoading, isFetching: getFeeInvoiceFetching } =
    useQuery({
      queryKey: ["getFeeInvoiceByInvoiceNumber", invoiceId],
      queryFn: () =>
        getFeeInvoice({ invoiceNumber: String(invoiceId).replace(/ /g, "/") }),
      onSuccess: (value) => {
        const feeTypeArray = [];
        value.data?.obj?.invoiceItems?.forEach((res) => {
          if (
            !feeTypeArray.map((item) => item.feeType).includes(res?.feeType)
          ) {
            feeTypeArray.push({
              feeType: res?.feeType,
              totalAmount: 0,
              months: [],
              extraDiscountAmount: 0,
              paidFineAmount: 0,
              balanceAmount: 0,
            });
          }
        });
        feeTypeArray?.forEach((res) => {
          value.data?.obj?.invoiceItems?.forEach((invoice) => {
            if (invoice?.feeType === res?.feeType) {
              res["months"] = [...res?.months, invoice?.monthYear];
              res["totalAmount"] =
                res?.totalAmount +
                Number(invoice?.thisInvoiceObject?.trasactionAmount ?? 0);
              res["extraDiscountAmount"] =
                res?.extraDiscountAmount +
                Number(invoice?.thisInvoiceObject?.extraDiscountAmount ?? 0);
              res["paidFineAmount"] =
                res?.paidFineAmount +
                Number(invoice?.thisInvoiceObject?.paidFineAmount ?? 0);
              res["balanceAmount"] =
                res?.balanceAmount +
                Number(invoice?.thisInvoiceObject?.balanceAmount ?? 0);
            }
          });
        });
        setData(value?.data?.obj);
        setInvoiceItems(feeTypeArray);
      },
      onError: (err) => {
        toast.error(err?.response?.data?.message);
      },
      enabled: state.template === "template1" ? true : false,
    });
  const {
    isLoading: getFeeInvoiceLoading2,
    isFetching: getFeeInvoiceFetching2,
  } = useQuery({
    queryKey: ["getFeeInvoiceByInvoiceNumber2", invoiceId],
    queryFn: () =>
      getFeeInvoiceTemplate2({
        invoiceNumber: String(invoiceId).replace(/ /g, "/"),
      }),
    onSuccess: (value) => {
      const feeTypeArray = [];
      value.data?.obj?.invoiceItems?.forEach((res) => {
        if (!feeTypeArray.map((item) => item.feeType).includes(res?.feeType)) {
          feeTypeArray.push({
            feeType: res?.feeType,
            totalAmount: 0,
            months: [],
            extraDiscountAmount: 0,
            paidFineAmount: 0,
            balanceAmount: 0,
          });
        }
      });
      feeTypeArray?.forEach((res) => {
        value.data?.obj?.invoiceItems?.forEach((invoice) => {
          if (invoice?.feeType === res?.feeType) {
            res["months"] = [...res?.months, invoice?.monthYear];
            res["totalAmount"] =
              res?.totalAmount +
              Number(invoice?.thisInvoiceObject?.trasactionAmount ?? 0);
            res["extraDiscountAmount"] =
              res?.extraDiscountAmount +
              Number(invoice?.thisInvoiceObject?.extraDiscountAmount ?? 0);
            res["paidFineAmount"] =
              res?.paidFineAmount +
              Number(invoice?.thisInvoiceObject?.paidFineAmount ?? 0);
            res["balanceAmount"] =
              res?.balanceAmount +
              Number(invoice?.thisInvoiceObject?.balanceAmount ?? 0);
          }
        });
      });
      setData2(value?.data?.obj);
      setInvoiceItems2(value.data?.obj?.invoiceItems);
    },
    onError: (err) => {
      toast.error(err?.response?.data?.message);
    },
    enabled: state.template === "template2" ? true : false,
  });

  const calculateGrandTotal = () => {
    let total = 0;
    invoiceItems?.forEach((item) => {
      total += item?.totalAmount;
    });
    return total;
  };
  const calculateTotalDiscount = () => {
    let total = 0;
    invoiceItems?.forEach((item) => {
      total += item?.extraDiscountAmount;
    });
    return total;
  };
  const calculateTotalFine = () => {
    let total = 0;
    invoiceItems?.forEach((item) => {
      total += item?.paidFineAmount;
    });
    return total;
  };
  const calculateTotalBalance = () => {
    let total = 0;
    invoiceItems?.forEach((item) => {
      total += item?.balanceAmount;
    });
    return total;
  };

  return (
    <>
      <CustomLoader
        show={
          getFeeInvoiceLoading ||
          getFeeInvoiceFetching ||
          getFeeInvoiceLoading2 ||
          getFeeInvoiceFetching2
        }
      />

      {/* Print Configuration Section */}
      <Paper
        elevation={0}
        sx={{
          p: isMobile ? 1 : 2,
          mb: 1,
          bgcolor: "#f8f9fa",
          border: "1px solid #e0e0e0",
          borderRadius: "8px",
        }}
      >
        <Stack
          direction={isMobile ? "column" : "row"}
          spacing={2}
          alignItems={isMobile ? "stretch" : "center"}
          justifyContent="space-between"
        >
          {/* Template Selection - Compact */}
          <Stack
            direction="row"
            spacing={1}
            alignItems="center"
            flexWrap="wrap"
          >
            <ReceiptLongIcon color="secondary" fontSize="medium" />
            <Stack direction="row" spacing={1}>
              <Box
                onClick={() => patchFeeInvoicePrint({ template: "template1" })}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5,
                  px: 1,
                  py: 0.5,
                  borderRadius: "6px",
                  cursor: "pointer",
                  bgcolor:
                    state.template === "template1" ? "#f3e5f5" : "transparent",
                  border:
                    state.template === "template1"
                      ? "1px solid"
                      : "1px solid transparent",
                  borderColor: "secondary.main",
                  transition: "all 0.2s ease",
                  "&:hover": {
                    bgcolor:
                      state.template === "template1" ? "#f3e5f5" : "#f5f5f5",
                  },
                }}
              >
                <Radio
                  size="small"
                  color="secondary"
                  checked={state.template === "template1"}
                  onChange={(event) => {
                    patchFeeInvoicePrint({ template: event.target.value });
                  }}
                  value="template1"
                  sx={{ p: 0 }}
                />
                <Typography fontSize="13px" fontWeight={500}>
                  Template 1
                </Typography>
              </Box>

              <Box
                onClick={() => patchFeeInvoicePrint({ template: "template2" })}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5,
                  px: 1,
                  py: 0.5,
                  borderRadius: "6px",
                  cursor: "pointer",
                  bgcolor:
                    state.template === "template2" ? "#f3e5f5" : "transparent",
                  border:
                    state.template === "template2"
                      ? "1px solid"
                      : "1px solid transparent",
                  borderColor: "secondary.main",
                  transition: "all 0.2s ease",
                  "&:hover": {
                    bgcolor:
                      state.template === "template2" ? "#f3e5f5" : "#f5f5f5",
                  },
                }}
              >
                <Radio
                  size="small"
                  color="secondary"
                  checked={state.template === "template2"}
                  onChange={(event) => {
                    patchFeeInvoicePrint({ template: event.target.value });
                  }}
                  value="template2"
                  sx={{ p: 0 }}
                />
                <Typography fontSize="13px" fontWeight={500}>
                  Template 2
                </Typography>
              </Box>
            </Stack>
          </Stack>

          {/* Print Options - Compact */}
          <Stack
            direction="row"
            spacing={1.5}
            alignItems="center"
            flexWrap="wrap"
          >
            {/* School/Student Options */}
            <Stack
              direction="row"
              spacing={0.5}
              sx={{
                bgcolor: "#fff",
                px: 1.5,
                py: 0.5,
                borderRadius: "6px",
                border: "1px solid #e0e0e0",
              }}
            >
              <FormControlLabel
                control={
                  <Checkbox
                    checked={keepHeaderSpace}
                    onChange={(e) =>
                      patchFeeInvoicePrint({
                        keepHeaderSpace: e.target.checked,
                      })
                    }
                    color="secondary"
                    size="small"
                    sx={{ py: 0 }}
                  />
                }
                label="Space"
                componentsProps={{
                  typography: {
                    fontSize: "13px",
                    fontWeight: 500,
                  },
                }}
                sx={{ mr: 0 }}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    color="secondary"
                    size="small"
                    sx={{ py: 0 }}
                    checked={printTheme === "bw"}
                    onChange={(e) =>
                      patchFeeInvoicePrint({
                        printTheme: e.target.checked ? "bw" : "color",
                      })
                    }
                  />
                }
                label="B/W High Contrast"
                componentsProps={{
                  typography: {
                    fontSize: "13px",
                    fontWeight: 500,
                  },
                }}
                sx={{ mr: 0 }}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    color="secondary"
                    size="small"
                    sx={{ py: 0 }}
                    checked={state.school}
                    onChange={() =>
                      patchFeeInvoicePrint({
                        school: !feeInvoicePrint.school,
                      })
                    }
                  />
                }
                label="School"
                componentsProps={{
                  typography: {
                    fontSize: "13px",
                    fontWeight: 500,
                  },
                }}
                sx={{ mr: 0 }}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    color="secondary"
                    size="small"
                    sx={{ py: 0 }}
                    checked={state.student}
                    onChange={() =>
                      patchFeeInvoicePrint({
                        student: !feeInvoicePrint.student,
                      })
                    }
                  />
                }
                label="Student"
                componentsProps={{
                  typography: {
                    fontSize: "13px",
                    fontWeight: 500,
                  },
                }}
                sx={{ mr: 0 }}
              />
            </Stack>

            <Button
              variant="contained"
              color="secondary"
              size="small"
              startIcon={<PrintIcon fontSize="small" />}
              onClick={handlePrint}
              disabled={!state.school && !state.student}
            >
              Print
            </Button>
          </Stack>
        </Stack>
      </Paper>

      {/* Invoice Preview Section */}
      <Box
        sx={{
          background: "#F6F8FC",
          p: isMobile ? 1 : 1.5,
          borderRadius: "8px",
          border: "1px solid #e0e0e0",
        }}
      >
        <Stack
          direction="row"
          sx={{ width: isMobile ? "100%" : "60%", m: "auto" }}
        >
          {state.template === "template1" && (
            <InvoiceTemplate1
              invoiceText={"Invoice"}
              data={data}
              invoiceItems={invoiceItems}
              calculateGrandTotal={calculateGrandTotal}
              calculateTotalDiscount={calculateTotalDiscount}
              calculateTotalFine={calculateTotalFine}
              calculateTotalBalance={calculateTotalBalance}
              keepHeaderSpace={keepHeaderSpace}
              printTheme={printTheme}
            />
          )}
          {state.template === "template2" && (
            <InvoiceTemplate2
              invoiceText={"Invoice"}
              data2={data2}
              invoiceItems2={invoiceItems2}
              keepHeaderSpace={keepHeaderSpace}
              printTheme={printTheme}
            />
          )}
        </Stack>
        {state.template === "template1" && (
          <Box sx={{ display: "none" }}>
            <Stack
              direction="row"
              sx={{ p: 1 }}
              gap={0.5}
              ref={invoicePrintRef}
            >
              {state.school && (
                <InvoiceTemplate1
                  invoiceText={"School Invoice"}
                  data={data}
                  invoiceItems={invoiceItems}
                  calculateGrandTotal={calculateGrandTotal}
                  calculateTotalDiscount={calculateTotalDiscount}
                  calculateTotalFine={calculateTotalFine}
                  calculateTotalBalance={calculateTotalBalance}
                  keepHeaderSpace={keepHeaderSpace}
                  printTheme={printTheme}
                />
              )}
              {state.student && (
                <InvoiceTemplate1
                  invoiceText={"Student Invoice"}
                  data={data}
                  invoiceItems={invoiceItems}
                  calculateGrandTotal={calculateGrandTotal}
                  calculateTotalDiscount={calculateTotalDiscount}
                  calculateTotalFine={calculateTotalFine}
                  calculateTotalBalance={calculateTotalBalance}
                  keepHeaderSpace={keepHeaderSpace}
                  printTheme={printTheme}
                />
              )}
            </Stack>
          </Box>
        )}
        {state.template === "template2" && (
          <Box sx={{ display: "none" }}>
            <Stack
              direction="row"
              sx={{ p: 1 }}
              gap={0.5}
              ref={invoicePrintRef}
            >
              {state.school && (
                <InvoiceTemplate2
                  invoiceText={"School Invoice"}
                  data2={data2}
                  invoiceItems2={invoiceItems2}
                  keepHeaderSpace={keepHeaderSpace}
                  printTheme={printTheme}
                />
              )}
              {state.student && (
                <InvoiceTemplate2
                  invoiceText={"Student Invoice"}
                  data2={data2}
                  invoiceItems2={invoiceItems2}
                  keepHeaderSpace={keepHeaderSpace}
                  printTheme={printTheme}
                />
              )}
            </Stack>
          </Box>
        )}
      </Box>
      {/* </Container> */}
    </>
  );
}
